import './resources/css/font-awesome.min.css';
import './resources/css/main.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import { store } from './store';

import App from './App';

const el = document.getElementById('root');
const root = ReactDOM.createRoot(el);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />            
        </BrowserRouter>
    </Provider>);